import React from 'react';
import { createRoot } from 'react-dom/client';
import SearchContainer from './containers/SearchContainer';
import reportWebVitals from './reportWebVitals';
import makeServer from './helpers/makeServer';
import preload from './helpers/preload';
import bootstrap from './helpers/bootstrap';

const data = preload();

bootstrap(data);

if (process.env.NODE_ENV === 'development') {
  makeServer('development', data.api_namespace);
}

const container = document.getElementById('react-shp-search-placeholder');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <SearchContainer applyUrl={data.apply_url} />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
